import gql from 'graphql-tag';

export const GET_DEPARTMENT = gql`
  query GetDepartment($input: DepartmentInput!) {
    bpf {
      department(input: $input) {
        error
        success
        entity {
          id
          name
        }
      }
    }
  }
`;
